import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IResponseDto {
    authUrl: string,
}

/*
* Возвращает url для редиректа на Госуслуги
* https://master.esign.sandbox.d2c.r-one.io/docs/#/Esia/EsiaController_getAuthUrl
*/
export const authUrl = (redirectUrl: string): IRequest => ({
    uri: '/api/v1/esia/auth-url',
    method: 'GET',
    withProvider: true,
    withAuth: true,
    queryParams: {
        redirectUrl,
    },
});
